<template>
   
   <div class="column center" style="margin-bottom: 12px;">
        <p class="title">{{ title }}</p>
        <p v-if="desc" class="sub">{{ desc }}</p>   
   </div>
   
</template>
<script>

/*

    <PageTitle title="Jobs" desc="Something"/>
 
*/

export default {
    data: function () {return {}},
    props:{
        title: String,
        desc: String,        
    },    
}
</script>

<style scoped>

.title{
font-family: var(--titleFonts);
font-style: normal;
font-weight: 700;
font-size: 24px;
line-height: 32px;
text-align: center;
letter-spacing: 5%;
text-transform: uppercase;
color: var(--title);

}
.sub { 
    letter-spacing: 5%;     
    font-size: 9px; 
    font-weight: 500; 
    text-transform: uppercase; 
    color: var(--g4); 
    line-height: 14px; 
    margin: 0 0 6px; 
}

.ups { 
    letter-spacing: 5%;
}
</style>

